<template>
  <!-- On create new account -->
  <div class="wrapper" v-if="page_type === 'email'">
    <div class="logo">
      <router-link to="/">
        <img src="../assets/images/logo/new_logo.svg" />
      </router-link>
    </div>
    <h1 class="title">
      Welcome to
      <span class="bold">Consultified</span>
    </h1>
    <p v-if="!resend_loading">
      Your email address has not been verified yet. To complete the verification
      process, please click on the button below to resend the verification link.
    </p>
    <p v-else>Please wait while sending a message to your e-mail account...</p>

    <widgetButton :loading="resend_loading" @click="resentEmail()" class="btn-secondary btn-resent">
      Resend Verification
    </widgetButton>

    <widgetButton @click="backHome()" class="btn-transparent-secondary btn-back">
      Back Home
    </widgetButton>
  </div>
  <!-- On account which not activated -->
  <div class="wrapper" v-else-if="page_type === 'verify'">
    <div class="logo">
      <router-link to="/">
        <img src="../assets/images/logo/new_logo.svg" />
      </router-link>
    </div>
    <h1 class="title">
      Welcome to
      <span class="bold">Consultified</span>
    </h1>
    <p v-if="!resend_loading">
      Your email address has not been verified yet. To complete the verification
      process, please click on the button below to resend the verification link.
    </p>
    <p v-else>Please wait while sending a message to your e-mail account...</p>

    <widgetButton :loading="resend_loading" @click="resentEmail()" class="btn-secondary btn-resent">
      Resend Verification
    </widgetButton>

    <widgetButton @click="backHome()" class="btn-transparent-secondary btn-back">
      Back Home
    </widgetButton>
  </div>

  <!-- On outh -->
  <div class="wrapper" v-else-if="page_type === 'auth'">
    <div class="logo">
      <router-link to="/">
        <img src="../assets/images/logo/new_logo.svg" />
      </router-link>
    </div>
    <h1 class="title">
      Welcome to
      <span class="bold">Consultified</span>
    </h1>
    <p v-show="!verified && loading">Verifying your account...</p>
    <p v-show="verify_error">Error while verifying your account,Try again.</p>
    <p v-show="verified">Your account has been verified</p>

    <div class="loader" v-show="loading">
      <img src="@/assets/icons/loading_blue.gif" alt />
    </div>

    <widgetButton v-show="verified" :loading="loading" @click="appContinue()" class="btn-secondary btn-resent">
      Continue
    </widgetButton>

    <widgetButton v-show="verify_error" @click="backHome()" class="btn-transparent-secondary btn-back">
      Back Home
    </widgetButton>
  </div>
</template>
<script>
import { eventBus } from "../main";
export default {
  name: "account_activation",
  computed: {
    isInvited() {
      return !(
        this.$cookies.get("project-token") === null &&
        this.$cookies.get("employment-token") === null
      );
    },
  },
  data() {
    return {
      loading: false,
      verified: false,
      verify_error: false,
      page_type: "auth",
      verification_data: {},
      resend_loading: false,
    };
  },
  mounted() {
    let vm = this;
    if (vm.$route.query.type) {
      vm.page_type = vm.$route.query.type;
    }
    if (vm.$route.query.type && vm.$route.query.reference) {
      let type = vm.$route.query.type;
      let reference = vm.$route.query.reference;
      if (type === "auth") {
        vm.page_type = "auth";
        vm.verifyAccount(reference);
      } else {
        vm.verify_error = true;
      }
    } else {
      vm.verify_error = true;
    }
  },
  methods: {
    backHome() {
      let vm = this;
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ name: "login" });
    },
    resentEmail() {
      let vm = this;
      vm.resend_loading = true;
      vm.$store
        .dispatch("RESEND_VERIFY_EMAIL_ACCOUNT", {
          reference: vm.$route.query.reference,
        })
        .then((responce) => {
          vm.resend_loading = false;
        })
        .catch((error) => {
          vm.resend_loading = false;
        });
    },
    verifyAccount(reference) {
      let vm = this;
      vm.loading = true;
      vm.$store
        .dispatch("VERIFY_ACCOUNT", { reference: reference })
        .then((response) => {
          vm.verified = true;
          vm.loading = false;
          vm.verification_data = response.data;
          this.$cookies.set(
            "account-type",
            parseInt(response.data.account_type)
          );
          vm.$localStorage.set(
            "logged_user_data",
            JSON.stringify(response.data)
          );

          let user_data = response.data;
          sessionStorage.authToken = user_data.access_token;
          sessionStorage.setItem("isLogedIn", true);
          sessionStorage.setItem("account_type", user_data.account_type);
          eventBus.$socket.emit("register", user_data.id);
          vm.$store.commit("AUTH_REQUEST", user_data);
          vm.$store.commit("INITIALIZE_APP_DATA", {
            token: user_data.access_token,
            id: user_data.id,
          });
        })
        .catch((error) => {
          vm.verify_error = true;
          vm.loading = false;
        });
    },
    appContinue() {
      let vm = this;
      let data = vm.verification_data;
      if (data.verified) {
        if (this.isInvited) {
          vm.$router.push({ name: "invitation_wizard" });
        } else {
          if (data.activated === false) {
            vm.$router.push({ name: "get-started" });
          } else {
            vm.$router.push({ name: "feeds" });
          }
        }
      } else {
        vm.$router.push({
          name: "account_activation",
          query: { type: "verify" },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/main";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;

  .logo {
    margin-bottom: 40px;

    img {
      width: 150px;
    }
  }

  h1.title {
    font-size: 25px;
    font-weight: 300;
    margin-bottom: 40px;

    .bold {
      font-weight: 800;
    }
  }

  p {
    text-align: center;
    padding: 0 20px;
    width: 600px;
  }

  .btn-resent {
    margin: 30px 0px;
  }

  .btn-back {
    margin-top: 20px;
  }
}
</style>
